function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SET_FIELD, REMOVE_FIELD, INITIALIZE, SET_CEF_APPLICATION_FIELD } from "../Actions/ActionTypes";
import { ValidateKey, setValidKeys } from "../Utilities/Validators";
export var initialState = {
  applicationLoaded: false,
  applicationCompleteOnLoad: false,
  updatedKeys: [],
  validKeys: [],
  application: {
    nationality: null,
    stateOfResidence: null,
    validStudyPermitsOrVisas: null,
    englishProficiencyTest: null,
    standardizedTests: {
      gmat: false,
      gre: false,
      dont_have: false
    },
    gmatTest: {
      value: false,
      t: '',
      tp: '',
      v: '',
      vp: '',
      q: '',
      qp: '',
      w: '',
      wp: ''
    },
    greTest: {
      value: false,
      v: '',
      vp: '',
      q: '',
      qp: '',
      w: '',
      wp: ''
    },
    countryOfResidence: null,
    educationCountry: null,
    educationLevel: null,
    educationStatus: null,
    degree: null,
    educationType: null,
    mostRecentOverallGrade: {
      gradingSchemeId: null,
      grade: '',
      gradeMax: null
    }
  }
};
var CefApplicationReducer = function CefApplicationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_FIELD:
      {
        var _action$payload = action.payload,
          key = _action$payload.key,
          value = _action$payload.value;
        ValidateKey(key, state.application);
        var updatedValidKeys = setValidKeys(key, value, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          updatedKeys: state.updatedKeys.indexOf(key) > -1 ? state.updatedKeys : [].concat(_toConsumableArray(state.updatedKeys), [key]),
          application: _objectSpread(_objectSpread({}, state.application), {}, _defineProperty({}, key, value)),
          validKeys: updatedValidKeys
        });
      }
    case SET_CEF_APPLICATION_FIELD:
      {
        var _action$payload2 = action.payload,
          _key = _action$payload2.key,
          _value = _action$payload2.value;
        ValidateKey(_key, state);
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _key, _value));
      }
    case REMOVE_FIELD:
      {
        var _key2 = action.payload;
        ValidateKey(_key2, state.application);
        return _objectSpread(_objectSpread({}, state), {}, {
          application: _objectSpread(_objectSpread({}, state.application), {}, _defineProperty({}, _key2, null))
        });
      }
    case INITIALIZE:
      {
        var _value2 = action.payload;
        return _value2 !== null && _value2 !== void 0 && _value2.CefApplication ? _objectSpread(_objectSpread({}, _value2.CefApplication), {}, {
          applicationLoaded: true
        }) : _objectSpread(_objectSpread({}, initialState), {}, {
          applicationLoaded: true
        });
      }
    default:
      return state;
  }
};
export default CefApplicationReducer;